import { Quote } from "lucide-react";

const stories = [
  {
    name: "Tami",
    location: "Florida",
    quote:
      "Tami shares how decades of depression finally met meaningful improvement in just a few days with the SAINT® protocol.",
    embedId: "_moGR41xPE0",
  },
  {
    name: "Jeannie",
    location: "Out of state",
    quote:
      "Jeannie traveled far after battling long-term, treatment-resistant depression — and found rapid relief through SAINT at Neuro Wellness.",
    embedId: "ZTE7dEEYzeY",
  },
];

export const SaintStories = () => (
  <section className="py-16 sm:py-20 bg-background">
    <div className="container-px mx-auto max-w-6xl px-4">
      <div className="text-center mb-10">
        <h2 className="font-headings text-2xl font-bold text-primary sm:text-3xl lg:text-4xl">
          SAINT patients in their own words
        </h2>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-2 max-w-3xl mx-auto">
        {stories.map((story, idx) => (
          <div
            key={idx}
            className="rounded-2xl border border-border bg-card p-6 shadow-soft"
          >
            <Quote className="h-6 w-6 text-accent/40 mb-3" />
            <p className="text-sm text-foreground/85 leading-relaxed italic">
              {story.quote}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-accent text-sm font-bold text-accent-foreground">
                {story.name.charAt(0)}
              </div>
              <div>
                <p className="text-sm font-bold text-primary">{story.name}</p>
                <p className="text-xs text-muted-foreground">
                  {story.location}
                </p>
              </div>
            </div>
            <div className="mt-4 aspect-video w-full overflow-hidden rounded-lg bg-muted">
              <iframe
                src={`https://www.youtube.com/embed/${story.embedId}`}
                title={`${story.name}'s SAINT® experience`}
                className="h-full w-full"
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                loading="lazy"
              />
            </div>
            <p className="mt-3 text-xs text-muted-foreground">
              Individual results vary.
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
